import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

/**
 * Docs: https://github.com/ember-cli/ember-cli-deprecation-workflow
 */
setupDeprecationWorkflow({
    /**
    false by default, but if a developer / team wants to be more aggressive about being proactive with
    handling their deprecations, this should be set to "true"
  */
    throwOnUnhandled: false,
    workflow: [
        /* ... handlers ... */
        /* to generate this list, run your app for a while (or run the test suite),
         * and then run in the browser console:
         *
         *    deprecationWorkflow.flushDeprecations()
         *
         * And copy the handlers here
         */
        { handler: 'silence', matchId: 'ember-string.add-package' },
        { handler: 'silence', matchId: 'ember-string.from-ember-module' },
        /* example: */
        /* { handler: 'silence', matchId: 'template-action' }, */
    ],
});
